const excludedMarcaTerms = ['huawei', 'ekit', 'datacom', 'hw'];

const normalizeText = (value = '') =>
    value
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();

export const shouldShowMarca = (marca) => {
    const searchableText = [marca?.Codigo, marca?.Descripcion, marca?.Nombre, marca?.nombre]
        .filter(Boolean)
        .map(normalizeText)
        .join(' ');

    return !excludedMarcaTerms.some((term) => searchableText.includes(normalizeText(term)));
};

export const shouldShowSuggestion = (suggestion) => {
    const searchableText = typeof suggestion === 'string'
        ? suggestion
        : [suggestion?.label, suggestion?.nombre, suggestion?.Descripcion, suggestion?.marca, suggestion?.Marca, suggestion?.Codigo]
            .filter(Boolean)
            .join(' ');

    return !excludedMarcaTerms.some((term) => normalizeText(searchableText).includes(normalizeText(term)));
};

export const excludedMarcaTermsList = excludedMarcaTerms;
